<template #pageContent>
  <page-outline :title="$t('Webheader.mandat_list_cdtr')">
    <template slot="pageContent">
  <b-container fluid v-if="!hasLinks">
    <span>No content available.</span>
  </b-container>

  <b-container fluid v-else>
    <b-row class="mt-3 align-items-center">
      <b-col cols="auto">
        <back-button class="btnFilter_2 mr-2 btn-back" :returnUrl="returnUrl"></back-button>
      </b-col>

      <b-col class="d-flex justify-content-end" cols="auto">
        <b-button class="btnFilter_2 mr-2 w-100" @click="exportMandate">
          <i class="fa-light fa-upload"></i>
          {{ $t('mandate.export') }}
        </b-button>

        <b-button class="btnFilter_2 mr-2" @click="newMandate" variant="primary">
          <i class="fa-light fa-plus"></i>
          <span class="fab-label">{{ $t('mandate.new_mandate') }}</span>
        </b-button>

        <b-button class="btnFilter_2 mr-2 w-100" @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ $t('filter.fltr') }}
        </b-button>

        <b-button class="btnFilter_2 w-100" @click="onRefresh">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>

    <hr class="mx-auto" />

    <!-- FILTERS -->
    <b-row v-if="displayFilter" class="min-w-100 justify-content-start align-items-center">
      <b-col cols="3" >
        <span class="filter-item-title d-block mb-1">{{ $t('mandate.unique_mandate_rf') }}</span>
        <input v-model.trim="idFilter" class="filter-item-content w-100" style="padding:0.12rem;" placeholder="e.g. FR12ZZZ000000000123456-2025-00001" />
      </b-col>

      <b-col cols="3">
        <span class="filter-item-title d-block mb-1">{{ $t('mandate.status_collection') }}</span>
        <select v-model="statusFilter" class="filter-item-content w-100" style="padding:0.35rem;">
          <option value="All">──────────</option>
          <option v-for="s in statuses" :key="s" :value="s">{{ s }}</option>
        </select>
      </b-col>

      <b-col cols="3">
        <div>
          <span class="filter-item-title d-block mb-1">{{ $t('Webheader.date_begin') }}</span>
          <datetime-picker-custom class="z-1" format="YYYY-MM-DD HH:mm:ss"

            periodFull
            id="filter-datebegin"
            :class="{'filter-item-input': true, 'filter-item-input-complete': dateBeginFilter}"
            customInputParentClass="filter-item-content"
            customInputClass="w-100"
            style="padding:0.35rem"
            :maxLength="19"
            :placeholderValue="$t('common.datepicker_format_date2')"
            inputIcon="fa-solid fa-calendar"
            v-model="dateBeginFilter"/>
        </div>
      </b-col>

      <b-col cols="3">
        <div>
          <span class="filter-item-title d-block mb-1">{{ $t('Webheader.date_end') }}</span>
          <datetime-picker-custom
            format="YYYY-MM-DD HH:mm:ss"
            periodFull
            id="filter-dateend"
            class= "mr-3"
            :class="{'filter-item-input': true, 'filter-item-input-complete': dateEndFilter}"
            customInputParentClass="filter-item-content"
            customInputClass="w-100"
            style="padding:0.35rem"
            :maxLength="19"
            :placeholderValue="$t('common.datepicker_format_date2')"
            inputIcon="fa-solid fa-calendar"
            v-model="dateEndFilter"/>
        </div>
      </b-col>

      <b-row class="min-w-100 justify-content-end align-items-center">
        <b-col cols="12" class="d-flex justify-content-end mt-3">
          <b-button class="btnFilter_2 mr-2" @click="clearFilterFields" :disabled="!hasInputFilter">{{ $t('common.rst') }}</b-button>
          <b-button class="btnFilter_2" @click="applyFilter">{{ $t('common.srch') }}</b-button>
        </b-col>
      </b-row>
    </b-row>

    <hr class="mx-auto mb-4" v-if="displayFilter"/>
    <!-- TABLE (liste seule) -->
    <b-row>
      <b-col cols="12" class="mx-auto mb-4">
        <div style="overflow:auto">
          <b-table v-if="filteredMandates.length > 0"
            hover
            striped
            responsive
            class="table table-striped"
            style="margin-bottom:0"
            :items="mandates"
            :fields="fields"
            :empty-text="$t('common.security.no_result')"
            primary-key="id"
            @row-clicked="onRowClick"
            :tbody-tr-class="()=>'table-row-clickable'"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDir"
            @head-clicked="sortTable"
            :key="refreshKey"
          >
            <template #cell(status)="data">
              <span :class="['chip','chip--' + statusVariant(data.value)]">{{ $t('mandate.status_mandate_' + data.value) }}</span>
            </template>

            <template #cell(actions)="{ item }">
              <b-link @click.stop.prevent="onRowClick(item)" class="text-decoration-none">
                {{ $t('mandate.view_details') }}
              </b-link>
            </template>
          </b-table>
          <div v-else class="d-flex justify-content-center">
            <span class="noResult">
              {{ $t('common.no_result') }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>
</page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import { loadPage } from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import { errorMessageAlert } from "@/helpers/alert"
import moment from 'moment-timezone'
import BackButton from '@/components/common/backButton.vue'
import Pagination from '@/components/common/pagination.vue'

export default {
  name: 'MandateDetailBulk',
  components: {
    BackButton,
    'page-outline': PageOutline,
    'datetime-picker-custom': dateTimePicker,
    'cm-pagination': Pagination
  },

  data () {
    return {
      links: { mandates: true },
      displayFilter: true,
      perPage: 15,
      page: 1,

      // données affichées (page courante uniquement)
      mandates: [],

      // filtres (UI)
      idFilter: '',
      statusFilter: 'All',
      dateBeginFilter: null,
      dateEndFilter: null,

      // pagination (serveur)
      paginationObject: {},
      pageCounter: 0,

      // tri côté serveur (si dispo)
      filterConditions: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false,

      fields: [
        { key: 'id', label: this.$t('mandate.unique_mandate_rf'), sortable: true, class: 'text-center' },
        { key: 'debtor', label: this.$t('mandate.dbtr'), sortable: true, class: 'text-center' },
        { key: 'CreationDate', label: this.$t('mandate.date_creation'), sortable: true, class: 'text-center' },
        { key: 'status', label: this.$t('mandate.status_collection'), sortable: true, class: 'text-center status-col' },
        { key: 'actions', label: this.$t('mandate.actions'), class: 'text-center' }
      ],

      statuses: [
        this.$t('mandate.status_mandate_0'),
        this.$t('mandate.status_mandate_1'),
        this.$t('mandate.status_mandate_2'),
        this.$t('mandate.status_mandate_3'),
        this.$t('mandate.status_mandate_4'),
        this.$t('mandate.status_mandate_5'),
        this.$t('mandate.status_mandate_6'),
        this.$t('mandate.status_mandate_7'),
        this.$t('mandate.status_mandate_10')
      ],
      activateSpinner: false,
      timezone: '+00:00',
      MandateListExport: {},
    }
  },
  created() {
    this.returnUrl = '/mandatpage/bulk'
    this.IdMandateBulk = this.$route.query.IdMandateBulk
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    // this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getMandat(index)
      that.pageCounter = 0
    })

    this.pageCounter = 0
    this.onRefresh()
  },

  computed: {
    hasLinks () { return this.links && Object.keys(this.links).length },

    hasInputFilter () {
      return !!this.idFilter || this.statusFilter !== 'All' || this.dateBeginFilter || this.dateEndFilter
    },
    filteredMandates () { return this.mandates },

    // filteredMandates () {
    //   let items = this.mandates.slice()
    //
    //   if (this.idFilter) {
    //     const q = String(this.idFilter).toLowerCase()
    //     items = items.filter(m => String(m.id).toLowerCase().includes(q))
    //   }
    //
    //   if (this.statusFilter && this.statusFilter !== 'All') {
    //     items = items.filter(m => m.status === this.statusFilter)
    //   }
    //
    //   if (this.dateBeginFilter || this.dateEndFilter) {
    //     const toDate = (val) => {
    //       if (!val) return null
    //       const d = new Date(String(val).replace(' ', 'T'))
    //       return isNaN(d) ? null : d
    //     }
    //     const toDateFromRow = (rowVal) => rowVal ? new Date(`${rowVal}T00:00:00`) : null
    //
    //     const from = toDate(this.dateBeginFilter)
    //     const to = toDate(this.dateEndFilter); if (to) to.setHours(23,59,59,999)
    //
    //     items = items.filter(m => {
    //       const rowDate = toDateFromRow(m?.CreationDate)
    //       if (!rowDate) return false
    //       if (from && rowDate < from) return false
    //       if (to && rowDate > to) return false
    //       return true
    //     })
    //   }
    //
    //   return items
    // },

    startRow () { return (this.page - 1) * this.perPage },
    endRow () { return Math.min(this.startRow + this.perPage, this.paginationObject.nbResultsTotal) }
  },

  mounted () {
    this.$bus?.emit?.('set-small-panel')
  },

  methods: {
    // ======= API =======
    // onPageChange (newPage) {
    //   this.page = newPage
    //   this.paginationObject.maxResults = this.perPage
    //   this.paginationObject.firstIndex = (this.page - 1) * this.perPage + 1
    //   this.getMandat(this.paginationObject.firstIndex)
    // },
    applyFilter (filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getMandat()
    },
    toApiDateTime (val) {
      if (!val) return null
      // si c’est déjà un objet Date → on formate
      if (val instanceof Date && !isNaN(val)) {
        return moment(val).format('YYYY-MM-DDTHH:mm:ss')
      }
      // sinon, on travaille sur la string
      const s = String(val).trim()
      if (!s) return null
      if (s.includes('T')) return s
      return s.replace(/\s+/, 'T')
    },
    buildApiParams ({ index = 1, forExport = false } = {}) {
      const params = {
        IdMandateBulk: this.IdMandateBulk,
        maxResults: this.paginationObject.maxResults,
        firstIndex: index
      }

      if (this.idFilter) params.UMR = this.idFilter
      if (this.statusFilter && this.statusFilter !== 'All') {
        params.status = this.statusLabelToCode(this.statusFilter)
      }
      if (this.dateBeginFilter) params.dateBegin = this.toApiDateTime(this.dateBeginFilter)
      if (this.dateEndFilter)   params.dateEnd   = this.toApiDateTime(this.dateEndFilter)

      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }

      if (forExport) {
        params.export = 1
        // reprendre tout le dataset
        params.firstIndex = 1
        params.maxResults = this.paginationObject.nbResultsTotal || 100000
      }

      return params
    },
    getMandat (index = 1) {
      this.activateSpinner = true
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      const params = this.buildApiParams({ index, forExport: false })
      this.$engine.Mandat.getMandat(params)
        .then((resp) => {
          const payload = resp && resp.data ? resp.data : {}
          const rawList = Array.isArray(payload.Mandates) ? payload.Mandates : []

          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          this.paginationObject.nbResults = resp.data.Mandates.length

          const rows = rawList
            .map(this.mapApiMandateToRow)
            .filter(Boolean)
          this.updateMandates(rows)
        })
        .finally(() => {
          this.$f7?.pullToRefreshDone?.()
          this.activateSpinner = false
        })
    },

    // === mapping enrichi: on capture un éventuel id_mandate ===
    mapApiMandateToRow (m) {
      const umr = m && m.UMR ? String(m.UMR) : ''
      if (!umr) return null

      const CreationDate = this.formatIsoToYmd(m?.creation_date)
      const SigningDate  = this.formatIsoToYmdHms(m?.signing_md_date)
      const SigningCancelDate = this.formatIsoToYmdHms(m?.signing_cancel_date)

      const latestCol = this.pickLatestCollection(m?.Collections)

      const SettlementDate = this.formatIsoToYmd(latestCol?.settlement_date)
      const dueDate        = this.formatIsoToYmd(latestCol?.due_date)
      const DebitDate      = this.formatIsoToYmd(latestCol?.debit_date)
      const amount = this.safeNumber(latestCol?.amount)

      return {
        // colonnes déjà utilisées
        id: umr,                                  // UMR
        debtor: m?.dbtr_name || '',               // Debtor
        CreationDate,                             // Creation Date
        status: m?.status || '',

        // colonnes pour l’export
        id_contract: m?.id_contract != null ? String(m.id_contract) : '',
        type_transaction: m?.type_transaction ?? '',
        type_transaction_label: this.txTypeLabel(m?.type_transaction),
        reason_mandate: m?.reason_mandate || '',
        signing_md_date: SigningDate,
        signing_cancel_date: SigningCancelDate,
        dbtr_iban: m?.dbtr_iban || '',
        dbtr_email: m?.dbtr_email || '',
        dbtr_id: m?.dbtr_id || '',
        dbtr_addr: m?.dbtr_addr || '',
        dbtr_city: m?.dbtr_city || '',
        dbtr_country: m?.dbtr_country || '',
        schema_code: m?.schema_code || '',

        // autres infos utiles (pas forcément exportées)
        creditor: m?.cdtr_name || '',
        amount,
        SettlementDate,
        dueDate,
        DebitDate,
        reference: (m?.id_contract != null && m.id_contract !== '') ? String(m.id_contract) : (latestCol?.cdtr_ref || ''),
        notes: m?.reason_mandate || '',
        mandateId: m?.id_mandate ?? m?.MandateId ?? null
      }
    },



    // updateMandates (rows) {
    //   this.mandates = Array.isArray(rows) ? rows : []
    // },
    //
    // // ======= Mapping / Utils =======
    // mapApiMandateToRow (m) {
    //   // UMR obligatoire pour l’affichage (colonne "id")
    //   const umr = m && m.UMR ? String(m.UMR) : ''
    //   if (!umr) return null
    //
    //   // dates (format API: 'YYYY-MM-DDTHH:mm:ss' ou vide)
    //   const CreationDate   = this.formatIsoToYmd(m?.creation_date)
    //
    //   // Prend la collection la plus “récente” si dispo, sinon rien
    //   const latestCol = this.pickLatestCollection(m?.Collections)
    //
    //   const SettlementDate = this.formatIsoToYmd(latestCol?.settlement_date)
    //   const dueDate        = this.formatIsoToYmd(latestCol?.due_date)
    //   const DebitDate      = this.formatIsoToYmd(latestCol?.debit_date)
    //
    //   // Montant (peut arriver vide dans ton exemple)
    //   const amount = this.safeNumber(latestCol?.amount)
    //
    //   // id_contract peut être non quoté côté back → on cast en string
    //   const reference = (m?.id_contract != null && m.id_contract !== '')
    //     ? String(m.id_contract)
    //     : (latestCol?.cdtr_ref || '')
    //
    //   return {
    //     // === clés EXACTEMENT attendues par tes <fields> ===
    //     id: umr,                               // 'Unique Mandate References'
    //     debtor: m?.dbtr_name || '',            // 'Debtor'
    //     CreationDate,                          // 'Creation Date'
    //     status: this.statusCodeToLabel(m?.status), // 'Status' (label lisible)
    //     // colonnes non affichées mais utiles (export, détails)
    //     creditor: m?.cdtr_name || '',
    //     amount,
    //     SettlementDate,
    //     dueDate,
    //     DebitDate,
    //     reference,
    //     notes: m?.reason_mandate || ''
    //   }
    // },


    pickLatestCollection (cols) {
      if (!Array.isArray(cols) || !cols.length) return null
      const toTs = (d) => {
        if (!d) return 0
        const t = Date.parse(String(d).replace(' ', 'T'))
        return isNaN(t) ? 0 : t
      }
      return cols.slice().sort((a, b) => {
        const aMax = Math.max(
          toTs(a?.debit_date),
          toTs(a?.settlement_date),
          toTs(a?.due_date),
          toTs(a?.collection_creation_date)
        )
        const bMax = Math.max(
          toTs(b?.debit_date),
          toTs(b?.settlement_date),
          toTs(b?.due_date),
          toTs(b?.collection_creation_date)
        )
        return bMax - aMax
      })[0]
    },

    formatIsoToYmd (val) {
      if (!val) return ''
      const d = new Date(String(val).replace(' ', 'T'))
      if (isNaN(d)) return ''
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`
    },

    safeNumber (n) {
      const x = Number(n)
      return isNaN(x) ? '' : x
    },

    statusCodeToLabel(code) {
      const key = code != null ? String(code) : '';
      const map = {
        '0':  this.$t('mandate.status_mandate_0'),
        '1':  this.$t('mandate.status_mandate_1'),
        '2':  this.$t('mandate.status_mandate_2'),
        '3':  this.$t('mandate.status_mandate_3'),
        '4':  this.$t('mandate.status_mandate_4'),
        '5':  this.$t('mandate.status_mandate_5'),
        '6':  this.$t('mandate.status_mandate_6'),
        '7':  this.$t('mandate.status_mandate_7'),
        '10': this.$t('mandate.status_mandate_10')
      };
      return map[key] ?? this.$t('mandate.status_mandate_pending')
    },
    statusLabelToCode(label) {
      const map = {
        [this.$t('mandate.status_mandate_0')]: '0',
        [this.$t('mandate.status_mandate_1')]: '1',
        [this.$t('mandate.status_mandate_2')]: '2',
        [this.$t('mandate.status_mandate_3')]: '3',
        [this.$t('mandate.status_mandate_4')]: '4',
        [this.$t('mandate.status_mandate_5')]: '5',
        [this.$t('mandate.status_mandate_6')]: '6',
        [this.$t('mandate.status_mandate_7')]: '7',
        [this.$t('mandate.status_mandate_10')]: '10'
      };
      return map[label] ?? '0';
    },

    // ======= UI callbacks =======
    formatCurrency (n) {
      if (n === '' || n === null || typeof n === 'undefined') return ''
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Number(n))
    },

    statusVariant(status) {
      const map = {
        0: 'warning',
        1: 'success',
        2: 'danger',
        3: 'info',
        4: 'danger',
        5: 'success',
        6: 'orange',
        7: 'secondary',
        10: 'secondary'
      };
      return map[status] || 'secondary';
    },

    onRowClick (item) {
      loadPage(this, { url: `/mandatedetail/${item.mandateId}` + '?IdMandateBulk=' + this.IdMandateBulk })
    },

    // exportCurrentPage () {
      // const headers = ['Mandate ID','Creditor','Debtor','Amount','Settlement Date','Due Date','Debit Date','Status']
      // const rows = this.filteredMandates.map(m => [
      //   m.id, m.creditor, m.debtor, this.formatCurrency(m.amount),
      //   m.SettlementDate, m.dueDate, m.DebitDate, m.status
      // ])
      // const csv = [headers, ...rows]
      //   .map(r => r.map(v => `"${String(v ?? '').replace(/"/g,'""')}"`).join(';'))
      //   .join('\n')
      //
      // const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      // const url = URL.createObjectURL(blob)
      //
      // const now = new Date()
      // const pad = n => String(n).padStart(2, '0')
      // const yyyy = now.getFullYear()
      // const mm = pad(now.getMonth() + 1)
      // const dd = pad(now.getDate())
      // const HH = pad(now.getHours())
      // const MM = pad(now.getMinutes())
      // const SS = pad(now.getSeconds())
      // const filename = `${yyyy}${mm}${dd}_${HH}${MM}${SS}_mandates_list.csv`
      //
      // const a = document.createElement('a')
      // a.href = url
      // a.download = filename
      // a.click()
      // URL.revokeObjectURL(url)
    // },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'id',
        'debtor',
        'CreationDate',
        'SettlementDate',
        'status'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    newMandate () {
      loadPage(this, { url: '/formpage/cdtr' })
    },
    clearFilterFields () {
      this.idFilter = ''
      this.statusFilter = 'All'
      this.dateBeginFilter = null
      this.dateEndFilter = null
      // this.applyFilter()
      // this.page = 1
      // this.onPageChange(this.page)
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getMandat()
    },

    formatIsoToYmd (val) {
      if (!val) return ''
      const d = new Date(String(val).replace(' ', 'T'))
      if (isNaN(d)) return ''
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`
    },
    formatIsoToYmdHms (val) {
      if (!val) return ''
      const d = new Date(String(val).replace(' ', 'T'))
      if (isNaN(d)) return ''
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    txTypeLabel (n) {
      const num = Number(n)
      if (num === 1) return 'One-off'
      if (num === 2) return 'Recurrent'
      return String(n ?? '')
    },
    safeNumber (n) {
      const x = Number(n)
      return isNaN(x) ? '' : x
    },
    pickLatestCollection (cols) {
      if (!Array.isArray(cols) || !cols.length) return null
      const toTs = (d) => {
        if (!d) return 0
        const t = Date.parse(String(d).replace(' ', 'T'))
        return isNaN(t) ? 0 : t
      }
      return cols.slice().sort((a, b) => {
        const aMax = Math.max(toTs(a?.debit_date), toTs(a?.settlement_date), toTs(a?.due_date), toTs(a?.collection_creation_date))
        const bMax = Math.max(toTs(b?.debit_date), toTs(b?.settlement_date), toTs(b?.due_date), toTs(b?.collection_creation_date))
        return bMax - aMax
      })[0]
    },
    updateMandates (rows) {
      // ⚠️ Vue 2: remplacer la référence suffit pour la réactivité
      this.mandates = Array.isArray(rows) ? rows : []
    },
    refreshList () {
      this.page = 1
      this.mandates = this.mandates.slice()
      this.applyFilter()
    },
    async exportMandate () {
      try {
        this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))

        // 🔁 Réappel API en mode export
        const params = this.buildApiParams({ forExport: true })
        const resp = await this.$engine.Mandat.getMandat(params)
        const payload = resp && resp.data ? resp.data : {}
        const rawList = Array.isArray(payload.Mandates) ? payload.Mandates : []

        // map sans toucher this.mandates (pas d’effet UI)
        const rows = rawList.map(this.mapApiMandateToRow).filter(Boolean)

        // En-têtes EXACTS et dans l’ordre demandé
        const headers = [
          this.$t('mandate.unique_mandate_rf'),
          this.$t('mandate.underlying_contract_id'),
          'Debtor Name',
          'Debtor IBAN',
          'Debtor email',
          'Debtor Id',
          'Address of Debtor',
          'City of Debtor',
          'Country of residence',
          this.$t('mandate_details.creation_date'),
          this.$t('mandate_details.date_signed'),
          this.$t('mandate_details.cancel_date'),
          this.$t('mandate_details.type_transaction'),
          this.$t('mandate_details.reason'),
          this.$t('mandate.schema'),
          this.$t('mandate_details.status')
        ]

        const esc = v => `"${String(v ?? '').replace(/"/g, '""')}"`

        const body = rows.map(r => ([
          r.id,
          r.id_contract,
          r.debtor,
          r.dbtr_iban,
          r.dbtr_email,
          r.dbtr_id,
          r.dbtr_addr,
          r.dbtr_city,
          r.dbtr_country,
          r.CreationDate,
          r.signing_md_date,
          r.signing_cancel_date,
          // mets le code ou le label selon ton besoin :
          // r.type_transaction,
          r.type_transaction_label,
          r.reason_mandate,
          r.schema_code,
          r.status
        ].map(esc).join(';')))

        const csv = [headers.map(esc).join(';'), ...body].join('\r\n')

        const linkSource = 'data:text/csv;charset=utf-8;base64,' + btoa(csv)
        const fileName = `${this.$t('Webheader.mandat_list_cdtr')}${moment().unix()}.csv`

        if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          const a = document.createElement('a')
          a.href = linkSource
          a.download = fileName
          a.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      } catch (e) {
        errorMessageAlert(this, e)
      } finally {
        this.$f7.hidePreloader()
        this.$f7.pullToRefreshDone()
      }
    }
  }
}
</script>
<style scoped>

/* chips */
.status-col { width: 180px; }
.chip{
  --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151;
  display:inline-flex; align-items:center; justify-content:center;
  height:28px; min-width:150px; padding:0 .75rem; border-radius:999px;
  font-size:.75rem; font-weight:600; letter-spacing:.2px;
  border:1px solid var(--chip-border); background-color:var(--chip-bg); color:var(--chip-fg); white-space:nowrap;
}
.chip--success{ --chip-border:#16a34a; --chip-bg:rgba(22,163,74,.10); --chip-fg:#166534; }
.chip--warning{ --chip-border:#f59e0b; --chip-bg:rgba(245,158,11,.12); --chip-fg:#92400e; }
.chip--orange{  --chip-border:#fb923c; --chip-bg:rgba(251,146,60,.12); --chip-fg:#9a3412; }
.chip--danger{  --chip-border:#ef4444; --chip-bg:rgba(239,68,68,.10); --chip-fg:#991b1b; }
.chip--secondary{ --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151; }
.chip--info{ --chip-border:#60a5fa; --chip-bg:rgba(96,165,250,.12); --chip-fg:#0b4a6f; }
</style>
